import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IoMdClose } from "react-icons/io";
import "./warningModal.css";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { BiBorderRadius } from "react-icons/bi";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import API from "../../../../network/index";
import { ignoreSpacesAndUrlsFromMsg } from "src/Utils/commonUtils";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 5,
  px: 4, // padding left + right
  py: 2, // padding top + bottom
};

export default function WarningModal(props) {
  const {
    isWarningModalOpen,
    warnOrBlockUserId,
    tenantId,
    tenantName,
    warnOrBlockUserName,
    onWarnModalClose,
    modalType,
  } = props;
  const userDetails = useSelector(
    (state) => state.SignInReducer?.userDetails || {}
  );

  const [warningReason, setWarningReason] = useState("");
  const [confModalVisible, setConfModalVisible] = useState(null);

  useEffect(() => {
    if (!isWarningModalOpen) {
      setWarningReason("");
    }
  }, [isWarningModalOpen]);

  const onClose = () => {
    setConfModalVisible(null);
  };

  const onChangeReason = (e) => {
    const value = e.target.value.replace(/^\s+/, "");
    setWarningReason(value);
  };

  const warnCommunityUser = async () => {
    try {
      const formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("userId", warnOrBlockUserId);
      formData.append("warnMessage", warningReason);
      const response = await API.warnUser(formData);
      if (response?.data?.status) {
        onWarnModalClose();
        setConfModalVisible({
          open: true,
          type: "success",
          title: response?.data?.status,
          acceptLabel: "Ok",
          onAccept: onClose,
        });
      }
    } catch (error) {
      console.error("Error in sending warning:", error);
      alert("Failed to send warning. Please try again.");
    }
  };

  const blockCommunityUser = async () => {
    try {
      const formData = new FormData();
      formData.append("tenantId", tenantId);
      formData.append("selectedIds", warnOrBlockUserId);
      formData.append("blockReason", warningReason);
      const response = await API.blockUserWithReason(formData);
      if (response?.data?.status) {
        onWarnModalClose();
        setConfModalVisible({
          open: true,
          type: "success",
          title: response?.data?.status,
          acceptLabel: "Ok",
          onAccept: onClose,
        });
        props?.onRefreshMembersData();
      }
    } catch (error) {
      console.error("Error in block request:", error);
      alert("Failed to send block request. Please try again.");
    }
  };

  const placeholderText =
    modalType === "warn"
      ? "Explain the reason for sending a warning"
      : "Explain the reason for blocking access";

  return (
    <div>
      <Modal
        open={isWarningModalOpen}
        onClose={onWarnModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="warn-modal-header">
            <button
              type="button"
              onClick={() => {
                onWarnModalClose();
                setWarningReason("");
              }}
            >
              <IoMdClose className="block-modal-close-icon" />
            </button>
          </div>
          <div>
            <p>Dear {warnOrBlockUserName},</p>
            {modalType === "warn" ? (
              <p>
                Your community Moderator in {tenantName} has sent a warning
                because you are not in compliance with{" "}
                <span>
                  <Link to={"/UserGuideLines"} target="_blank">
                    User Guidelines
                  </Link>
                </span>{" "}
                of Skopic.
              </p>
            ) : (
              <p>
                Your community Moderator has blocked your access in {tenantName}{" "}
                because you are not in compliance with{" "}
                <span>
                  <Link to={"/UserGuideLines"} target="_blank">
                    User Guidelines
                  </Link>
                </span>{" "}
                of Skopic.
              </p>
            )}
          </div>
          <div>
            <label htmlFor="warningReasonField">Reason:</label>
            <textarea
              rows={5}
              cols={20}
              id="warningReasonField"
              value={warningReason}
              onChange={onChangeReason}
              placeholder={placeholderText}
              className="warn-reason-textarea"
              maxLength={280}
            />
            <p className="char-count">{warningReason.length}/280</p>
          </div>
          <button
            type="submit"
            className="unblock-req-send-button"
            onClick={
              modalType === "warn" ? warnCommunityUser : blockCommunityUser
            }
          >
            {/* {true ? <CircularProgress size={20} color="white" /> : "Send"} */}
            Send
          </button>
        </Box>
      </Modal>
      {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />}
    </div>
  );
}
